export enum HistoricType {
  GIVES_CLASSES = 'GIVES_CLASSES',
  TEACHER_ATTENDANCE = 'TEACHER_ABSENCE',
  STUDENT_ABSENCE = 'STUDENT_ABSENCE',
}
